import { ReactNode } from 'react'
import { Document } from '@contentful/rich-text-types'
import { IProps as IText } from 'marketing-site/src/library/elements/Text'

export { HeadingBase } from './component'

export type BodyGap = 'default' | 'medium' | 'large' | 'huge'

export interface IProps {
  brand?: IText['brand']
  theme?:
    | 'none'
    | 'blue-gradient'
    | 'aqua-gradient'
    | 'marigold-gradient'
    | 'clay-gradient'
    | 'rainbow-gradient'
  width?: 'narrow' | 'default' | 'wide' | 'full'
  alignment?: 'start' | 'center'
  icon?: ReactNode
  eyebrow?: string
  title?: string
  titleSize?: 'heading-1--mega' | 'heading-1' | 'heading-1--small' | 'heading-2' | 'heading-3'
  subheadSize?: 'subhead-sm' | 'subhead-lg'
  subhead?: Document | string
  listStyle?: string
  ctas?: ReactNode | ReactNode[]
  footnote?: Document
}
